import {sendStats} from '@github-ui/stats'
import {sendToHydro} from './hydro-stats'
import {wasServerRendered} from '@github-ui/ssr-utils'
import {shouldReportLongAnimationFrame} from './utils/suppression'

// Observers run for all sessions. Hydro receives all data; Datadog is gated on session sampling.
export const observeLongAnimationFrames = () => {
  if (
    typeof PerformanceObserver !== 'undefined' &&
    (PerformanceObserver.supportedEntryTypes || []).includes('long-animation-frame')
  ) {
    const observer = new PerformanceObserver(function (list) {
      const longAnimationFrameEntries = list.getEntries()
      // Filter out non-representative long animation frames (debugger pauses, extreme durations)
      const filteredEntries = longAnimationFrameEntries.filter(entry => shouldReportLongAnimationFrame(entry))
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const longAnimationFrames = filteredEntries.map(({name, duration, blockingDuration}: any) => ({
        name,
        duration,
        blockingDuration,
        url: window.location.href,
      }))

      if (longAnimationFrames.length > 0) {
        sendToHydro({longAnimationFrames: filteredEntries, ssr: wasServerRendered()})
        sendStats({longAnimationFrames})
      }
    })
    observer.observe({type: 'long-animation-frame', buffered: true})
  }
}
